export const foundRouteDataHelper = (key: string, firstChild?: { data: any; firstChild?: any }) => {
  if (firstChild && firstChild?.data[key]) {
    return firstChild?.data;
  }
  if (firstChild && firstChild.firstChild) {
    return foundRouteDataHelper(key, firstChild.firstChild);
  }
  return null;
};
